// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1793081149013
      var cssReload = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/@vue/cli-service/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  